export default {
    getDoctorHeaderFields: state => state.doctorHeaderFields,
    getDoctorDataTableOptions: state => state.doctorDataTableOptions,
    getDoctorFormActions: state => state.doctorFormActions,
    getDoctorActions: state => state.doctorActions,
    getDoctorRowActions: state => state.doctorRowActions,
    isDoctorFormOpen: state => state.doctorFormIsOpen,
    isDoctorGridOpen: state => state.doctorGridIsOpen,

    getExamHeaderFields: state => state.examHeaderFields,
    getExamFormActions: state => state.examFormActions,
    getExamActions: state => state.examActions,
    getExamRowActions: state => state.examRowActions,
    isExamFormOpen: state => state.examFormIsOpen,
    isExamGridOpen: state => state.examGridIsOpen,

    getLanguageHeaderFields: state => state.languageHeaderFields,
    getLanguageFormActions: state => state.languageFormActions,
    getLanguageActions: state => state.languageActions,
    getLanguageRowActions: state => state.languageRowActions,
    isLanguageFormOpen: state => state.languageFormIsOpen,
    isLanguageGridOpen: state => state.languageGridIsOpen,

    getFeeActions: state => state.feeActions,
    isFeeFormOpen: state => state.feeFormIsOpen,
    isFeeGridOpen: state => state.feeGridIsOpen,
}
